const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8050';

export const submitContact = async (data) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.detail || 'Failed to send message. Please try again.');
  }
  return payload;
};
